import React from 'react';

import { AiSuggestedComponentProps } from 'redux/schemas/models/ai-course-creation';
import { ComponentType } from 'redux/schemas/models/lecture-component';

const ActivityTitle = ({ componentSet }: AiSuggestedComponentProps) => {
  const { activity, secondaryActivities } = componentSet;
  const getActivityTitle = () => {
    switch (activity.type) {
      case ComponentType.PROFILE_COMPLETION:
        return activity.profileRequirement.title;
      case ComponentType.MEET_AND_GREET:
        return secondaryActivities[0].content;
      case ComponentType.POLL:
        return activity.poll.title;
      case ComponentType.EXERCISE:
        return activity.exercise.title;
      case ComponentType.PUBLIC_PEER_EVALUATION:
        return activity.peerEvaluation.title;
      case ComponentType.TOPIC:
        return activity.topic.title;
      case ComponentType.QUIZ:
        return activity.quiz.title;
      case ComponentType.SURVEY:
        return activity.survey.title;
      default:
        return null;
    }
  };

  return (<div className='text-lg-bold'>{getActivityTitle()}</div>);
};

export default ActivityTitle;
